import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { filter, firstValueFrom, Subscription } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { WindowEnums } from 'src/app/enum/window-enums';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { InventoryReportFilterModel } from 'src/app/models/inventory/inventory-report-filter.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { StoreService } from 'src/app/services/archive/store.service';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InventoryPeriodService } from 'src/app/services/inventory/inventory-period.service';
import { InventoryReportService } from 'src/app/services/inventory/inventory-report.service';
import { InventoryService } from 'src/app/services/inventory/inventory.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CustomValidators } from 'src/app/validators/custom-validators';

@Component({
  selector: 'app-stock-min',
  standalone: false,
  templateUrl: './stock-min.component.html',
  styleUrls: ['./stock-min.component.scss']
})
export class StockMinComponent implements OnInit {

  branchId: number = 0;
  changeFilters: boolean = false;
  dataReport: CustomTableReport;
  formInventoryReportFilter: FormGroup = new FormGroup({});
  isOpened: string | undefined = undefined;
  inventoryId: number = 0;
  listArticles: any[] = [];
  listBranches: any[] = [];
  listInventories: any[] = [];
  listObservers: Array<Subscription> = new Array<Subscription>();
  listStores: any[] = [];
  nameWindow: string = 'Informe Topes Mínimos';
  permissionUpdatable: boolean = false;
  permissionsUser: OptionWindowModel[] = [];
  projectName = ProjectName.projectName;
  storeId: number = 0;
  url: string = 'stock-min-report';
  userAuthenticated: UserModel = new UserModel();

  constructor(private articleService: ArticleService,
    private branchService: BranchService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private inventoryEntryService: InventoryService,
    private inventoryPeriodService: InventoryPeriodService,
    private inventoryService: InventoryService,
    private inventoryReportService: InventoryReportService,
    private toastHandlerService: ToastHandlerService,
    private optionWindowService: OptionWindowService,
    private storeService: StoreService,
    private title: Title,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService
  ) {
    this.validateForm();
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    await this.getAllLists();
    await Promise.all([
      this.getFirstInventoryByCompanyAuthenticated(),
      this.getFirstBranchByUserAuthenticated()
    ]);
    await this.loadStoresByBranchInventory();
    this.getLastInventoryPeriod();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }

    this.listObservers.forEach(sub => sub.unsubscribe());
  }

  changeArticle(articleId: number | null) {
    if (articleId === 0 || articleId === null) {
      this.formInventoryReportFilter.controls["articleId"].patchValue(0);
    }
    this.changeFilter();
  }

  async changeBranch(branchId: number | null) {
    const validBranch = branchId ?? 0;

    this.branchId = validBranch;
    this.formInventoryReportFilter.controls["branchId"].patchValue(validBranch);

    await this.onInventoryOrBranchChange();
  }

  changeFilter() {
    this.changeFilters = false;
  }

  async changeInventory(inventoryId: number | null) {
    const validInventory = inventoryId ?? 0;

    this.inventoryId = validInventory;
    this.formInventoryReportFilter.controls["inventoryId"].patchValue(validInventory);

    await this.onInventoryOrBranchChange();
  }

  async changeStore(storeId: number | null) {
    const validStore = storeId ?? 0;
    this.storeId = validStore;
    this.formInventoryReportFilter.controls["storeId"].patchValue(validStore);
  }

  clear() {
    this.changeFilter();
    this.validateForm();
    this.getLastInventoryPeriod();
    this.getFirstInventoryByCompanyAuthenticated();
  }

  async exportExcel() {
    if (this.changeFilters) {
      const datePeriod = this.formInventoryReportFilter.get("periodDate")?.value;
      const periodDate = `${datePeriod.getFullYear()}-${(datePeriod.getMonth() + 1).toString().padStart(2, '0')}`;
      const period = periodDate.slice(5);
      const year = periodDate.slice(0, -3);

      const modelInventoryReportFilterStockMin = this.formInventoryReportFilter.value as InventoryReportFilterModel;
      modelInventoryReportFilterStockMin.year = parseInt(year);
      modelInventoryReportFilterStockMin.period = parseInt(period);
      try {
        const response = await firstValueFrom(this.inventoryReportService.exportInventoryReportStockMin(modelInventoryReportFilterStockMin));
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Informe de Topes MÍximos.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al exportar el informe.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para exportar'
      );
    }
  }

  async getAllLists() {
    try {
      const [inventories, branches, articles,] = await Promise.all([
        firstValueFrom(this.inventoryEntryService.getAllInventoriesForSelectAsync()),
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.articleService.getAllArticlesForSelectAsync())
      ]);
      this.listInventories = inventories;
      this.listBranches = branches;
      this.listArticles = articles;
      return true;
    } catch (error) {
      console.error('Error cargando listas', error);
      return false
    }
  }

  async getFirstBranchByUserAuthenticated() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.branchId = response.branchId;
      this.formInventoryReportFilter.get('branchId')?.patchValue(this.branchId);
    } catch (error) {
      console.error('Error al obtener la sucursal.', error);
    }
  }

  async getFirstInventoryByCompanyAuthenticated() {
    try {
      const response = await firstValueFrom(this.inventoryService.getFirstInventoryByCompanyAuthenticatedAsync());
      this.inventoryId = response.inventoryId;
      this.formInventoryReportFilter.get('inventoryId')?.patchValue(this.inventoryId);
    } catch (error) {
      console.error('Error al obtener inventario principal de la compañia.', error);
    }
  }

  async getLastInventoryPeriod() {
    try {
      const inventoryPeriod = await firstValueFrom(this.inventoryPeriodService.getLastInventoryPeriod());
      this.formInventoryReportFilter.controls["periodDate"].patchValue(moment(inventoryPeriod.initialDate).startOf('month').toDate());
    } catch (error) {
      console.error("Error al consultar el periodo de inventario:", error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);

    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(
        AuthenticationContants.keyWindowsOpenedLocalStorage,
        JSON.stringify(windowsOpened)
      );

      if (this.isOpened) {
        this.toastHandlerService.showToast('error', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`, 'Atención');
      }
    } else {
      localStorage.clear();
    }

    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      this.getPermissionsForUserByWindow();
    } catch (error) {
      console.error('Error al buscar los permisos por perfil.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
    this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.InventoryReportStockMin));
  }

  async loadStoresByBranchInventory() {
    if (!this.branchId || !this.inventoryId) {
      this.listStores = [];
      return;
    }

    try {
      this.listStores = await firstValueFrom(
        this.storeService.getStoresActivesByBranchInventoryForSelect(
          this.branchId,
          this.inventoryId
        )
      );
    } catch (error) {
      console.error('Error al cargar bodegas', error);
      this.listStores = [];
    }
  }

  async onInventoryOrBranchChange() {
    this.storeId = 0;
    this.formInventoryReportFilter.get('storeId')?.patchValue(0);
    this.formInventoryReportFilter.get('articleId')?.patchValue(0);
    await this.loadStoresByBranchInventory();
  }

  printReport() {
    if (this.changeFilters) {
      window.print();
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para imprimir.'
      );
    }
  }

  async send() {
    Object.keys(this.formInventoryReportFilter.controls).forEach(key => {
      const control = this.formInventoryReportFilter.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value: ', control.value);
      }
    });
    if (this.formInventoryReportFilter.valid) {
      //Obtengo los datos del periodo
      const datePeriod = this.formInventoryReportFilter.get("periodDate")?.value;
      const periodDate = `${datePeriod.getFullYear()}-${(datePeriod.getMonth() + 1).toString().padStart(2, '0')}`;
      const period = periodDate.slice(5);
      const year = periodDate.slice(0, -3);

      const modelInventoryReportFilterStockMin = this.formInventoryReportFilter.value as InventoryReportFilterModel;
      modelInventoryReportFilterStockMin.year = parseInt(year);
      modelInventoryReportFilterStockMin.period = parseInt(period);

      try {
        this.dataReport = await firstValueFrom(this.inventoryReportService.inventoryReportStockMin(modelInventoryReportFilterStockMin));
        if (this.dataReport.data && this.dataReport.data.length != 0 && this.dataReport.data.length != null) {
          this.changeFilters = true;
        } else {
          this.changeFilters = false;
          this.toastHandlerService.showToast('info', 'No se encontraron datos');
        }
      }
      catch (error) {
        console.error("Error al consultar el informe:", error);
      }
    } else {
      this.showValidationMessages();
    }

  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      periodDate: {
        required: 'El campo Período es obligatorio.'
      },
      inventoryId: {
        required: 'El campo Inventario es obligatorio.',
        min: 'Debe seleccionar un Inventario válido.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formInventoryReportFilter.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }


  validateForm() {
    this.formInventoryReportFilter = this.formBuilder.group({
      periodDate: ['', [Validators.required]],
      inventoryId: [0, [Validators.required, Validators.min(1)]],
      branchId: [0, [CustomValidators.numberOnlyValidator()]],
      storeId: [0, [CustomValidators.numberOnlyValidator()]],
      articleId: [0, [CustomValidators.numberOnlyValidator()]]
    });
  }
}